import { Navigation } from 'lucide-react';
import { useMapsPrefStore } from '../../store/mapsPrefStore';
import type { MapsApp } from '../../lib/directions';

const OPTIONS: { value: MapsApp; label: string }[] = [
  { value: 'auto', label: 'Auto-detect' },
  { value: 'apple', label: 'Apple Maps' },
  { value: 'google', label: 'Google Maps' },
  { value: 'waze', label: 'Waze' },
];

const SELECTED =
  'px-3 py-2 rounded-lg text-sm font-medium border border-blast-600 bg-blast-50 text-blast-700 dark:bg-blast-950/40 dark:text-blast-300 dark:border-blast-700';
const UNSELECTED =
  'px-3 py-2 rounded-lg text-sm font-medium border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors';

/**
 * Settings card: pick which maps app opens on "Directions".
 * Per-device preference (localStorage). Matches LocationSettings' card layout.
 */
export const MapsAppSettings = () => {
  const mapsApp = useMapsPrefStore((s) => s.mapsApp);
  const setMapsApp = useMapsPrefStore((s) => s.setMapsApp);

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-5">
      <div className="flex items-start gap-3">
        <Navigation className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Directions</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Choose which app opens when you tap “Directions” on a school or contact. Auto-detect
            uses your phone’s default (Apple Maps on iPhone, Google Maps on Android) and works for
            most people.
          </p>
          <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2">
            {OPTIONS.map((opt) => {
              const selected = mapsApp === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => setMapsApp(opt.value)}
                  aria-pressed={selected}
                  className={selected ? SELECTED : UNSELECTED}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
